import React, { useState } from "react";
import { Container, Col, Row } from "react-bootstrap";
import { Link } from "gatsby";
import "./assets/styles/_index.scss";
import parse from "html-react-parser";
import GetLink from "../functions/GetLink";
import GetGatsbyImage from "../common/site/get-gatsby-image";
import PlayVideo from "../PlayVideo/PlayVideo";
import GlobalFormModal from "../PopUpForm/PopUpForm";

const TileBlock = ({ title, heading, content, ctas, image, imgPosition, videoLink, Video_URL, pageTitle }) => {
  const [isPlay, setPlay] = useState(false);
  const [videourl, setVideourl] = useState(false);
  const isRentersRightsPage = pageTitle?.includes("Renters") || pageTitle?.includes("renters");
  const [show, setShow] = useState(false);
  const [fileUrl, setFileUrl] = useState(null);
  const closeGlobalForm = () => {
    setShow(false);
  };


  return (
    <section className="tile-block-wrapper section-m">
      <Container>
        <Row
          className={`tile-block-container ${imgPosition === "Left" ? "container-reverse" : ""}`}
        >
          <Col lg={5} className="order-lg-1 order-2">
            <div className="tile-block-details-wrapper">
              {title && <h4>{title}</h4>}
              {heading && <h2>{heading}</h2>}
              {content && <div className="tile-block-text">
                {parse(content, {
                  replace: (domNode) => {
                    if (domNode.name === "a" && domNode.attribs?.href === "#globalpopupform") {
                      return (
                        <a
                          onClick={() => setShow(true)}
                          className="tile-block-link"
                          style={{ cursor: "pointer" }}
                        >
                          {domNode.children.map((child, i) => child.data || parse(child, { replace: () => {} }))}
                        </a>
                      );
                    }
                  },
                })}
              </div>}
              {ctas?.length > 0 && (
                <div className={`d-flex align-items-center tile-block-link-wrapper ${isRentersRightsPage ? 'renters-rights-cta' : ''}`}>
                  {ctas?.map((cta, index) => (
                    <React.Fragment key={index}>
                      {cta.CTA_Secondary_Link === "#globalpopupform" ? (
                        <a
                          onClick={() => {
                            setFileUrl(cta?.Upload_Guide?.url || null);
                            setShow(true);
                          }}
                          className="tile-block-link"
                          style={{ cursor: "pointer" }}
                        >
                          {cta.CTA_Label}
                        </a>
                      ) : cta.CTA_Secondary_Link ? (
                        cta.CTA_Secondary_Link.startsWith("http") ? (
                          <a
                            href={cta.CTA_Secondary_Link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="tile-block-link"
                          >
                            {cta.CTA_Label}
                          </a>
                        ) : (
                          <Link
                            to={cta.CTA_Secondary_Link}
                            className="tile-block-link"
                            state={{
                              pageTitle: pageTitle,
                              file_url: cta?.Upload_Guide?.url || null,
                            }}
                          >
                            {cta.CTA_Label}
                          </Link>
                        )
                      ) : cta.CTA_Link ? (
                        <GetLink
                          link={cta.CTA_Link}
                          label={cta.CTA_Label}
                          className="tile-block-link"
                        />
                      ) : null}
                    </React.Fragment>
                  ))}
                </div>
              )}
            </div>
          </Col>
          <Col lg={1} className="order-lg-2 d-lg-block d-none"></Col>
          <Col lg={6} className="order-lg-3 order-1">
            <div className="tile-img-wrapper">
              {image && (
                // <GetGatsbyImage
                //   image={image}
                //   fallbackalt={image.alternativeText + "- block module image"}
                //   className="img-fluid"
                // />
                <img src={image.url} alt={image.alternativeText + "- block module image"}></img>
              )}
              {(videoLink || Video_URL) && (
                <a onClick={(e) => {setVideourl(videoLink ? videoLink : Video_URL); setPlay(true);}}><i className="icon icon-play"></i></a>
              )}
            </div>
          </Col>
        </Row>
      </Container>
      {isPlay && videourl && (
        <PlayVideo
          isOpen={isPlay}
          stopPlay={setPlay}
          videoId=""
          isCloseFunction={setPlay}
          videourl={videourl}
          htmlink={""}
        />
      )}
      <GlobalFormModal
        showGlobalForm={show}
        closeGlobalForm={closeGlobalForm}
        file_url={fileUrl}
      />
    </section>
  );
};

export default TileBlock;
